import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import styles from "../auth.module.scss";
import InputEmail from "components/input-email/input-email";
import InputName from "components/input-name/input-name";
import { mailIcon, mailModalIcon, noteIcon } from "base/SVG";
import InputPass from "components/input-pass/input-pass";
import Button from "components/primary-button/button";
import Select from "components/select/select";

// third party
import axios from 'axios';
import BarLoader from "react-spinners/BarLoader";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import HCaptcha from '@hcaptcha/react-hcaptcha';
import Turnstile, { useTurnstile } from "react-turnstile";

// project import
import { SERVER_URL } from '../../config';

export default function SignUp() {
  const urlParams = new URLSearchParams(window.location.search);
  const refCode = urlParams.get('refCode');

  const [referralCodeValue, setReferralCodeValue] = useState(refCode || "");
  const [social_media_acc, setSocialMediaValue] = useState("");
  const countries_iso_code = [
      { isoCode: "US", value: "United States" },
      { isoCode: "CA", value: "Canada" },
      { isoCode: "GB", value: "United Kingdom" },
      { isoCode: "AU", value: "Australia" },
      { isoCode: "DE", value: "Germany" },
      { isoCode: "FR", value: "France" },
      { isoCode: "IT", value: "Italy" },
      { isoCode: "JP", value: "Japan" },
      { isoCode: "KR", value: "South Korea" },
      { isoCode: "MX", value: "Mexico" },
      { isoCode: "NL", value: "Netherlands" },
      { isoCode: "RU", value: "Russia" },
      { isoCode: "ES", value: "Spain" },
      { isoCode: "SE", value: "Sweden" },
      { isoCode: "CH", value: "Switzerland" },
      { isoCode: "AE", value: "United Arab Emirates" },
      { isoCode: "AF", value: "Afghanistan" },
      { isoCode: "AL", value: "Albania" },
      { isoCode: "DZ", value: "Algeria" },
      { isoCode: "AS", value: "American Samoa" },
      { isoCode: "AD", value: "Andorra" },
      { isoCode: "AO", value: "Angola" },
      { isoCode: "AI", value: "Anguilla" },
      { isoCode: "AQ", value: "Antarctica" },
      { isoCode: "AG", value: "Antigua and Barbuda" },
      { isoCode: "AR", value: "Argentina" },
      { isoCode: "AM", value: "Armenia" },
      { isoCode: "AW", value: "Aruba" },
      { isoCode: "AT", value: "Austria" },
      { isoCode: "AZ", value: "Azerbaijan" },
      { isoCode: "BS", value: "Bahamas" },
      { isoCode: "BH", value: "Bahrain" },
      { isoCode: "BD", value: "Bangladesh" },
      { isoCode: "BB", value: "Barbados" },
      { isoCode: "BY", value: "Belarus" },
      { isoCode: "BE", value: "Belgium" },
      { isoCode: "BZ", value: "Belize" },
      { isoCode: "BJ", value: "Benin" },
      { isoCode: "BM", value: "Bermuda" },
      { isoCode: "BT", value: "Bhutan" },
      { isoCode: "BO", value: "Bolivia" },
      { isoCode: "BA", value: "Bosnia and Herzegovina" },
      { isoCode: "BW", value: "Botswana" },
      { isoCode: "BR", value: "Brazil" },
      { isoCode: "BN", value: "Brunei" },
      { isoCode: "BG", value: "Bulgaria" },
      { isoCode: "BF", value: "Burkina Faso" },
      { isoCode: "BI", value: "Burundi" },
      { isoCode: "KH", value: "Cambodia" },
      { isoCode: "CM", value: "Cameroon" },
      { isoCode: "CN", value: "China" },
      { isoCode: "CO", value: "Colombia" },
      { isoCode: "CR", value: "Costa Rica" },
      { isoCode: "HR", value: "Croatia" },
      { isoCode: "CU", value: "Cuba" },
      { isoCode: "CY", value: "Cyprus" },
      { isoCode: "CZ", value: "Czech Republic" },
      { isoCode: "DK", value: "Denmark" },
      { isoCode: "DO", value: "Dominican Republic" },
      { isoCode: "EC", value: "Ecuador" },
      { isoCode: "EG", value: "Egypt" },
      { isoCode: "EE", value: "Estonia" },
      { isoCode: "ET", value: "Ethiopia" },
      { isoCode: "FI", value: "Finland" },
      { isoCode: "GR", value: "Greece" },
      { isoCode: "HK", value: "Hong Kong" },
      { isoCode: "HU", value: "Hungary" },
      { isoCode: "IN", value: "India" },
      { isoCode: "ID", value: "Indonesia" },
      { isoCode: "IE", value: "Ireland" },
      { isoCode: "IL", value: "Israel" },
      { isoCode: "KE", value: "Kenya" },
      { isoCode: "KW", value: "Kuwait" },
      { isoCode: "MY", value: "Malaysia" },
      { isoCode: "NG", value: "Nigeria" },
      { isoCode: "NO", value: "Norway" },
      { isoCode: "NZ", value: "New Zealand" },
      { isoCode: "PH", value: "Philippines" },
      { isoCode: "PL", value: "Poland" },
      { isoCode: "PT", value: "Portugal" },
      { isoCode: "QA", value: "Qatar" },
      { isoCode: "RO", value: "Romania" },
      { isoCode: "SA", value: "Saudi Arabia" },
      { isoCode: "SG", value: "Singapore" },
      { isoCode: "TH", value: "Thailand" },
      { isoCode: "TR", value: "Turkey" },
      { isoCode: "UA", value: "Ukraine" },
      { isoCode: "VN", value: "Vietnam" },
      { isoCode: "ZA", value: "South Africa" },
      { isoCode: "ZW", value: "Zimbabwe" }
    ];
  
  
  const [selectedCountry, setSelectedCountry] = useState(countries_iso_code[0]);
  

  const navigate = useNavigate();
  const [form, setForm] = useState({
    firstname: "",
    lastname: "",
    email: "",
    password: "",
  });
  const updateForm = (data) => {
    setForm((form) => ({ ...form, ...data }));
  };
  
  
  useEffect(() => {
    if (refCode && refCode !== "") {
      // Set the refCOde as a cookie that expires in 30 days
      const date = new Date();
      date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000));
      document.cookie = `refCode=${refCode}; expires=${date.toUTCString()}; path=/`;
    }
  }, [refCode]);

  // Check the cookie for refCode
  if (!refCode) {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.startsWith('refCode=')) {
        const value = cookie.substring('refCode='.length, cookie.length);
        if (value && value !== "") {
          // Set the refCode from the cookie
          urlParams.set('refCode', value);
          window.history.replaceState({}, '', `${window.location.pathname}?${urlParams.toString()}`);
          setReferralCodeValue(value);
        }
      }
    }
  }

  useEffect(() => {
    const password = form.password;
    const passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/;
    if (passwordRegex.test(password)) {
      setPasswordWeak(false);
    } else {
      setPasswordWeak(true);
    }
  }, [form.password]);

  const [isSubmitting, setSubmitting] = useState(false);
  const [successfullyRegistered, setSuccessfullyRegistered] = useState(false);
  const [passwordWeak, setPasswordWeak] = useState(false);
  //const [hCaptchaToken, setHCaptchaToken] = useState('');
  const [turnstilToken, setTurnstileToken] = useState('');
  
  const turnstile = useTurnstile();

  /*const handleVerificationSuccess = (token, ekey) => {
    setHCaptchaToken(token);
  }*/

  const register = async (firstname, lastname, email, password) => {
    try {
      const response = await axios.post(SERVER_URL + '/api/auth/register',
        {
          firstname,
          lastname,
          email,
          password,
          turnstilToken,
          referralCodeValue,
          country: selectedCountry.isoCode,
          social_media_acc
        });

      // Check if status code is 201
      if (response.status === 201) {
        // Set token in cookies that expires in 12 hours
        setSuccessfullyRegistered(true);

        // Redirect to login page
        //window.location.href = '../../auth/sign-in';
      } else {
        toast.error(response.data.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
          });
      }
    }
    catch (error) {
      toast.error("Error occurred: " + error.response.data.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
        });
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    const { firstname, lastname, email, password } = form;

    if (!passwordWeak) {
      register(firstname, lastname, email, password);
    }
    setSubmitting(false);
  }

  return (
    <>
      {
        successfullyRegistered && (
          <div className={styles["auth__inner-head"]}>
            <div className={styles["auth__inner-icon"]}>{mailModalIcon}</div>
            <h3>Successfully Registered</h3>
            <p>
              Please check your email for the verification link. If you don't see the email, check other places it might be, like your junk, spam, social, or other folders.
            </p>
            <br />
            <div className={styles["auth__inner-btn"]}>
              <Button
                onClick={() => navigate("/auth/sign-in")}
                type={"gray"}
                text={"Go to Login"}
              />
            </div>
          </div>
        )
      }
      {
        !successfullyRegistered && (
          <>
            <ToastContainer />
            <div className={styles["auth__inner-head"]}>
              <h3>Create your Account</h3>
              <p>
                Already have an account? <Link to="sign-in">Log In</Link>
              </p>
            </div>

            <form>
              <InputName
                firstNameLabel={"First Name"}
                lastNameLabel={"Last Name"}
                firstNamePlaceholder={"Enter your first name"}
                lastNamePlaceholder={"Enter your last name"}
                onFirstNameChange={(e) => {
                  updateForm({ firstname: e.target.value });
                }}
                onLastNameChange={(e) => {
                  updateForm({ lastname: e.target.value });
                }}
                firstNameIcon={noteIcon}
                lastNameIcon={noteIcon}
              />
              <InputEmail
                label={"Email Address"}
                placeholder={"Enter your email"}
                onChange={(e) => {
                  updateForm({ email: e.target.value });
                }}
                icon={mailIcon}
                value={form.email}
              />
              <div className={styles["space"]}></div>
              <InputPass
                label={"Password"}
                placeholder={"Enter your password"}
                onChange={(e) => {
                  updateForm({ password: e.target.value });
                }}
                icon={mailIcon}
                value={form.password}
              />
              {
                passwordWeak && (
                  <p className={styles["note"]}>
                    {noteIcon}
                    Password Strength: At least eight characters, one uppercase, one
                    lowercase, a number and a special character
                  </p>
                )
              }
              <div className={styles["input__outer"]}>
                <label htmlFor="socialMedia">Social Account for Communications</label>
                <div className={styles["input"]}>
                  <input
                    type="text"
                    placeholder={"Discord/Telegram/X account"}
                    onChange={(e) => setSocialMediaValue(e.target.value)}
                    id="social_media_acc"
                    value={social_media_acc}
                  />
                </div>
              </div>
              <br />
              <div className={styles["input__outer"]}>
                <label htmlFor="refCode">Referral Code (Optional)</label>
                <div className={styles["input"]}>
                  <input
                    type="text"
                    id="refCode"
                    placeholder={"Enter your referral code"}
                    onChange={(e) => setReferralCodeValue(e.target.value)}
                    value={referralCodeValue}
                  />
                </div>
              </div>
              <br />
              <div className={styles["input__outer"]}>
                <p className="sm">Country</p>
                <div className={styles["select"]}>
                  <Select
                    list={countries_iso_code}
                    selected={selectedCountry}
                    searchable={true}
                    onChange={(country) => setSelectedCountry(country)}
                    placeholder="Search for your country"
                  />
                </div>
              </div>
              <br />
              <div className={styles["captcha-container"]}>
                {/*<HCaptcha
                  sitekey="3b3ceb76-6488-405a-baaa-42567dce94ca"
                  theme="dark"
                  onVerify={(token, ekey) => handleVerificationSuccess(token, ekey)}
                />*/}
                <Turnstile
                  sitekey="0x4AAAAAABDAr03RpRiRgyGt"
                  onVerify={(token) => {
                    setTurnstileToken(token);
                  }}
                />
              </div>
              <div className={styles["auth__inner-btn"]}>
                <Button
                  text="Sign Up"
                  type={"primary"}
                  onClick={(e) => handleSubmit(e)}
                  disabled={isSubmitting || passwordWeak || form.firstname === "" || form.lastname === "" || form.email === "" || form.password === "" || social_media_acc === ""}
                />
              </div>
            </form>
            <div className={styles["auth__inner-foot"]}>
              <p>
                By signing up, you agree to our <Link to="">Terms of Service </Link>{" "}
                and
                <Link to=""> Privacy Policy.</Link>
              </p>
            </div>
          </>
        )
      }
      
    </>
  );
}
